export default __webpack_public_path__ + "static/media/Artist2.09c835f4.svg";